/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ELogStatus = 'Created' | 'Edited' | 'Deleted';

export const ELogStatus = {
    Created: 'Created' as ELogStatus,
    Edited: 'Edited' as ELogStatus,
    Deleted: 'Deleted' as ELogStatus
};

